"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tokens = {"rotating":"CircularProgress_bMmzq","digby-circular-progress-rotating":"CircularProgress_DrByF"};
tokens._getCss = function () {return `/* imported from CircularProgress.css */ @keyframes CircularProgress_DrByF { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } .CircularProgress_bMmzq { animation: CircularProgress_DrByF 550ms linear infinite; } `;};
tokens._module = (typeof module !== "undefined") ? module : {id:"./common/src/svg/sync/CircularProgress_css.js"};
exports["default"] = tokens;